import React, { Fragment, forwardRef } from "react";
import { cs } from 'shared/utils/classnames';

export const TextInput = forwardRef(({
  label,
  value,
  placeholder,
  name,
  type,
  onChange,
  required,
  autoComplete,
  error,
  maxLength,
  minLength,
  disabled
} : {
  label?: string,
  value: string,
  placeholder?: string,
  name?: string,
  type?: React.InputHTMLAttributes<HTMLInputElement>["type"],
  onChange: (value: string, e: React.ChangeEvent<HTMLInputElement>) => any,
  required?: boolean,
  autoComplete?: React.InputHTMLAttributes<HTMLInputElement>["autoComplete"],
  error?: string,
  maxLength?: number,
  minLength?: number,
  disabled?: boolean,
}, ref: React.ForwardedRef<HTMLInputElement>) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange(e.target.value, e);
  };
  const className = cs('border bg-gray-100 rounded-md w-full py-2 px-4 text-lg font-light', {
    'border-red-200': !!error,
    'border-[#F5F5F5]': !error,
    'opacity-50': disabled
  });
  return (
    <Fragment>
      {label ? <div className="text-base text-gray-800 font-medium mb-1">{label}</div> : null}
      <input
        className={className}
        type={type}
        name={name}
        value={value}
        placeholder={placeholder}
        onChange={handleChange}
        required={required}
        autoComplete={autoComplete}
        maxLength={maxLength}
        minLength={minLength}
        disabled={disabled}
        ref={ref}
      />
      <div className="text-red-500 text-sm mb-2 min-h-[20px]">{error}</div>
    </Fragment>
  )
})
